import React from 'react';
import TransactionLogContent from '@/components/TransactionLog/TransactionLogContent';

export const PurchaseLogContent = (props) => (
  <TransactionLogContent type="purchase" {...props} />
);
